import { Place } from "../../models/Place";
import { Contact } from "../../models/Contact";
import { names } from "./names";
import { companies } from "./companies";
import { addresses } from "./real-us-addresses";

const titles = [
  "Marketing Coordinator",
  "Medical Assistant",
  "Web Designer",
  "Project Manager",
  "Administrative Manager",
  "Human Resources",
  "Office Clerk",
  "Executive Assistant",
  "Branch Manager"
];

export function generatePhoneNumber() {
  const areaCodes = [
    803,
    407,
    557,
    843,
    555,
    678,
    864,
    373,
    303,
    546,
    899,
    341
  ];
  const areaCode = areaCodes[Math.floor(Math.random() * areaCodes.length)];
  const nextThree = (Math.floor(Math.random() * 999) + 1).toLocaleString(
    "en-US",
    { minimumIntegerDigits: 3, useGrouping: false }
  );
  const lastFour = Math.floor(Math.random() * 9999).toLocaleString("en-US", {
    minimumIntegerDigits: 4,
    useGrouping: false
  });

  return `(${areaCode}) ${nextThree}-${lastFour}`;
}

export function getRandomAddress() {
  return addresses[Math.floor(Math.random() * addresses.length)];
}

export function generateRandomDate(start, end) {
  return new Date(
    start.getTime() + Math.random() * (end.getTime() - start.getTime())
  );
}

export function generateContacts(min = 0, max = 5) {
  let contacts = [];

  // Generate "random" number between min and max
  const numberOfLaborers = Math.floor(Math.random() * max) + min;

  for (let i = 0; i <= numberOfLaborers; i++) {
    const firstName =
      names.first[Math.floor(Math.random() * names.first.length)];
    const lastName = names.last[Math.floor(Math.random() * names.last.length)];
    const title = titles[Math.floor(Math.random() * titles.length)];
    const company = companies[Math.floor(Math.random() * companies.length)];
    const place = new Place(getRandomAddress());

    const contact = new Contact({
      id: Math.floor(Math.random() * 999999) + 1,
      name: `${firstName} ${lastName}`,
      email: `${lastName}${i + 1}@example.com`,
      phone: generatePhoneNumber(),
      title,
      company,
      places: [place]
    });

    contacts.push(contact);
  }

  return contacts;
}

export function getExistingContacts(min = 0, max = 5) {
  if (window.localStorage.customers) {
    const customers = JSON.parse(window.localStorage.customers).map(
      c => new Contact(c)
    );
    const actualMax = max <= customers.length ? max : customers.length;
    const numberOfContacts = Math.floor(Math.random() * actualMax) + min;
    const shuffledContacts = customers.sort(() => Math.random() - 0.5);

    return shuffledContacts.slice(0, numberOfContacts);
  }
  return [];
}

export function generateFiles(
  min = 1,
  max = 3,
  fileNamePrefix = "file",
  fileExtension = "pdf"
) {
  const files = [];
  const numberOfFiles = Math.floor(Math.random() * max) + min;

  for (let i = 1; i <= numberOfFiles; i++) {
    files.push({
      filename: `${fileNamePrefix}${i}.${fileExtension}`
    });
  }

  return files;
}
